import React, { useState, useEffect } from 'react';
import { homeAPI } from '../../../services/api';
import ImageUploader from '../Shared/ImageUploader';
import '../Shared/FormStyles.scss';
import './HomeContentManager.scss';

const HomeContentManager = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('hero');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await homeAPI.get();
      setContent(response.data);
    } catch (err) {
      setError('Failed to fetch content');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (section) => {
    setError('');
    setSuccess('');

    try {
      const updateData = content[section];
      if (section === 'hero') {
        await homeAPI.updateHero(updateData);
      } else if (section === 'about') {
        await homeAPI.updateAbout(updateData);
      }
      setSuccess('Content updated successfully');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to update content');
    }
  };

  const handleChange = (section, field, value) => {
    setContent({
      ...content,
      [section]: {
        ...content[section],
        [field]: value,
      },
    });
  };


  if (loading || !content) return <div>Loading...</div>;

  return (
    <div className="home-content-manager">
      <div className="admin-form">
        <h2>Home Content Management</h2>
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        <div className="tabs">
          <button className={activeTab === 'hero' ? 'active' : ''} onClick={() => setActiveTab('hero')}>Hero Section</button>
          <button className={activeTab === 'about' ? 'active' : ''} onClick={() => setActiveTab('about')}>About Section</button>
        </div>

        {activeTab === 'hero' && (
          <div className="tab-content">
            <div className="form-group">
              <label>Title</label>
              <input
                type="text"
                value={content.hero.title}
                onChange={(e) => handleChange('hero', 'title', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Description</label>
              <textarea
                value={content.hero.description}
                onChange={(e) => handleChange('hero', 'description', e.target.value)}
                rows={3}
              />
            </div>
            <div className="form-group">
              <label>Button Text</label>
              <input
                type="text"
                value={content.hero.buttonText}
                readOnly
              />
            </div>
            <ImageUploader
              value={content.hero.backgroundImage}
              onChange={(url) => handleChange('hero', 'backgroundImage', url)}
              label="Background Image"
            />
            <button type="button" className="dashboard-btn btn-primary" onClick={() => handleSave('hero')}>
              Save Hero Section
            </button>
          </div>
        )}

        {activeTab === 'about' && (
          <div className="tab-content">
            <div className="form-group">
              <label>Small Text</label>
              <input
                type="text"
                value={content.about.smallText}
                onChange={(e) => handleChange('about', 'smallText', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Title</label>
              <input
                type="text"
                value={content.about.title}
                onChange={(e) => handleChange('about', 'title', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Description</label>
              <textarea
                value={content.about.description}
                onChange={(e) => handleChange('about', 'description', e.target.value)}
                rows={5}
              />
            </div>
            <ImageUploader
              value={content.about.image}
              onChange={(url) => handleChange('about', 'image', url)}
              label="About Image"
            />
            <button type="button" className="dashboard-btn btn-primary" onClick={() => handleSave('about')}>
              Save About Section
            </button>
          </div>
        )}

      </div>
    </div>
  );
};

export default HomeContentManager;
